import { defineMessages } from 'react-intl';

export default defineMessages({
  goBack: { defaultMessage: 'Go back' },
  connect: { defaultMessage: 'Connect' },
});
